<template>
  <v-container fluid class="location-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-heart-box</v-icon>
            Location
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Location</p>
                      <v-text-field
                        class="mb-4"
                        type="Number"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'locationrank')"
                        v-bind:value="initvalue.locationrank"
                        placeholder="Location Rank"
                        persistent-hint
                        single-line hint="Enter the location rank">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'locationcode')"
                        v-bind:value="initvalue.locationcode"
                        placeholder="Location Code"
                        persistent-hint
                        single-line hint="Enter the location code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'locationname')"
                        v-bind:value="initvalue.locationname"
                        placeholder="Location Name"
                        persistent-hint
                        single-line hint="Enter the location name">
                      </v-text-field>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'locationstatus')"
                          v-bind:label="initvalue.locationstatus"
                          v-model="initvalue.locationstatus"
                          value="Active"
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items=items
                        :value="initvalue.locationtype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'locationtype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the location type">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'locationinfo')"
                        v-bind:value="initvalue.locationinfo"
                        placeholder="Location Info"
                        persistent-hint
                        single-line hint="Enter the location info">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'geolocation')"
                        v-bind:value="initvalue.geolocation"
                        placeholder="Geolocation"
                        persistent-hint
                        single-line hint="Enter the geolocation">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-textarea
                        outlined
                        v-bind:value="initvalue.locationaddress"
                        v-on:change="updateChangedValue($event, 'locationaddress')"
                        rows="3"
                        label="Location Address"
                        hint="please enter the location address"
                      ></v-textarea>
                      <v-select
                        class="mb-4"
                        :items="regions.map(x => {
                            return {text: x.regionname, value: x._id};
                          })"
                        :value="initvalue.regionid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'regionid')"
                        placeholder="Region"
                        persistent-hint
                        single-line hint="Please choose the region">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'locationphone')"
                        v-bind:value="initvalue.locationphone"
                        placeholder="Location Phone"
                        persistent-hint
                        single-line hint="Enter the location phone">
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="9">
                    <div class="d-flex justify-center">
                      <v-btn
                          to="/location/list"
                          replace
                          outlined
                          color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="editLocation()">
                          Save
                        </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/location/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      location: {},
      detail: {},
      photo: {},
      
      filename: null,
      initvalue: {},
      imageurl: undefined,
      upload: {},
      items: ['Head Office', 'Distribution Center', 'Warehouse', 'Depot', 'Outlet', 'Other'],
      switch1: false,
      switch2: false,
    }
  },
  computed: {
    ...mapState('Location', ['isReceiving']),
    ...mapState('Region', ['regions']),
  },
  methods: {
    ...mapActions('Location', ['updateLocationRequest','updateLocationImageRequest','updateLocationPinRequest','getLocationsRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    async editLocation() {
      this.location._id = this.initvalue._id;
      await this.updateLocationRequest(this.location);
      router.push('/location/list');
    },
    async editPhoto() {
      this.photo._id = this.initvalue._id;
      await this.updateLocationImageRequest(this.photo);
      router.push('/location/list');
    },
    updateChangedValue(value, field){
      this.location[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.locationimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    },
    onUploadChange(file) {
      if (!file) {return;}
      this.upload.locationimage = file;
      this.upload.imagename = file.name;
      console.log(this.upload);
    },
  },

  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'LocationList' });
    this.imageurl = this.initvalue.locationimage;
    if(this.regions.length==0) await this.getRegionsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
